const withLegacyId = (item) => {
  if (!item || typeof item !== 'object') return item

  if (item.id == null) return item

  return {
    ...item,
    _id: item._id ?? item.id
  }
}

export const isScheduleValidationsSuccess = (response) =>
  response?.code === 0 && response?.data != null

export const isScheduleValidationsHardError = (response) =>
  response?.data == null

/**
 * Maps GET /v1/schedules/validations response to the shape schedule UI expects.
 * Patients API uses `{ code, message, data }` instead of `{ success, message, data }`.
 */
export const mapScheduleValidationsResponse = (response) => {
  if (!response || typeof response !== 'object') return response

  const mapped = {
    ...response,
    success: isScheduleValidationsSuccess(response)
  }

  if (!mapped.data?.service) return mapped

  const { service, ...restData } = mapped.data

  mapped.data = {
    ...restData,
    service: {
      ...withLegacyId(service),
      paymentMethods: (service.paymentMethods ?? []).map(withLegacyId)
    }
  }

  return mapped
}
